export function increaseUnreadCount() {
  return {
    type: 'INCREASE_UNREAD_COUNT',
  };
}

export function decreaseUnreadCount() {
  return {
    type: 'DECREASE_UNREAD_COUNT',
  };
}

export function resetUnreadCount(detail) {
  return {
    type: 'RESET_UNREAD_COUNT',
    detail,
  };
}

export function setLastUpdatedMessageConversationId(detail) {
  return {
    type: 'SET_LAST_MESSAGE_CONVERSATION_ID',
    detail,
  };
}

export function setTextingHubViewers(detail) {
  return {
    type: 'SET_TEXTING_HUB_VIEWERS',
    detail,
  };
}

export function setLastMessageIdSentByOrg(detail) {
  return {
    type: 'SET_LAST_MESSAGE_ID_SENT_BY_ORG',
    detail,
  };
}

export function setLastMessageIdSentByUser(detail) {
  return {
    type: 'SET_LAST_MESSAGE_ID_SENT_BY_USER',
    detail,
  };
}

// `detail` is the textMessageMediaStored socket data: { _id, conversationId }.
// Socket.io creates a new object for every event, so the drawer's effect on
// this value runs for every event, including a second picture stored on the
// same message.
export function setLastStoredMediaMessage(detail) {
  return {
    type: 'SET_LAST_STORED_MEDIA_MESSAGE',
    detail,
  };
}

export function textSentByCurrentUser() {
  return {
    type: 'TEXT_SENT_BY_CURRENT_USER',
  };
}
